import { useIsDarkMode } from '@/lib/hooks/use-is-dark-mode';
import Lottie from 'react-lottie';
import animationData from '@/lotties/banner.json';
import animationDataDark from '@/lotties/banner-dark.json';

const LottieBanner = () => {
  const { isDarkMode } = useIsDarkMode();
  return (
    <div className="flex flex-col items-center">
      <Lottie
        isClickToPauseDisabled
        style={{ pointerEvents: 'none', marginBottom: '-20px' }}
        options={{
          loop: true,
          autoplay: true,
          animationData: isDarkMode ? animationDataDark : animationData,
          rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
          },
        }}
        width={500}
      />
    </div>
  );
};

export default LottieBanner;
